/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CheckMoveInDateUpdateEligibilityResponse } from './CheckMoveInDateUpdateEligibilityResponse';
import {
    CheckMoveInDateUpdateEligibilityResponseFromJSON,
    CheckMoveInDateUpdateEligibilityResponseFromJSONTyped,
    CheckMoveInDateUpdateEligibilityResponseToJSON,
} from './CheckMoveInDateUpdateEligibilityResponse';

/**
 * 
 * @export
 * @interface CheckMoveInDateUpdateEligibility200Response
 */
export interface CheckMoveInDateUpdateEligibility200Response {
    /**
     * 
     * @type {CheckMoveInDateUpdateEligibilityResponse}
     * @memberof CheckMoveInDateUpdateEligibility200Response
     */
    data?: CheckMoveInDateUpdateEligibilityResponse;
}

/**
 * Check if a given object implements the CheckMoveInDateUpdateEligibility200Response interface.
 */
export function instanceOfCheckMoveInDateUpdateEligibility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckMoveInDateUpdateEligibility200ResponseFromJSON(json: any): CheckMoveInDateUpdateEligibility200Response {
    return CheckMoveInDateUpdateEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckMoveInDateUpdateEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckMoveInDateUpdateEligibility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CheckMoveInDateUpdateEligibilityResponseFromJSON(json['data']),
    };
}

export function CheckMoveInDateUpdateEligibility200ResponseToJSON(value?: CheckMoveInDateUpdateEligibility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CheckMoveInDateUpdateEligibilityResponseToJSON(value.data),
    };
}

